import { render, staticRenderFns } from "./CovidPage.vue?vue&type=template&id=601e8b73&"
import script from "./CovidPage.vue?vue&type=script&lang=js&"
export * from "./CovidPage.vue?vue&type=script&lang=js&"
import style0 from "./CovidPage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports